import {
	loadClient,
	type SubeventHeaderType,
} from '@cx-modules/subevent-header';

export let SubeventHeader: SubeventHeaderType;

export const loadSubeventHeaderForClient = async () => {
	const response = await loadClient(ENV.CX_COMPONENTS_URL);

	SubeventHeader = response.Component;

	return response;
};
